function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "10.2,14.7 14.9,12 10.2,9.3 \t"
}), React.createElement("path", {
  className: "st0",
  d: "M0,0v24h24V0H0z M20.6,16.3c-0.2,0.8-0.8,1.4-1.6,1.6c-1.4,0.4-7,0.4-7,0.4s-5.6,0-7-0.4 c-0.8-0.2-1.4-0.8-1.6-1.6C3.1,14.9,3,13.5,3,12c0-1.5,0.1-2.9,0.4-4.4C3.6,6.9,4.2,6.3,5,6.1c1.4-0.4,7-0.4,7-0.4s5.6,0,7,0.4 c0.8,0.2,1.4,0.8,1.6,1.6C20.9,9.1,21,10.5,21,12C21,13.5,20.9,14.9,20.6,16.3z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      "enableBackground": "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/youtube.b913e38f.svg";
export { SvgComponent as ReactComponent };